/* =========================================================================
   INTIMMACY — theme behaviour
   ========================================================================= */
(function () {
  'use strict';

  var CFG = window.Intimmacy || {};
  var routes = CFG.routes || {};
  var strings = CFG.strings || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var on = function (el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); };

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    var fmt = CFG.moneyFormat || '₹{{amount}}';
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  /* ---------------------------------------------------------------- toasts */
  function toast(message, icon) {
    var host = $('[data-toasts]');
    if (!host) return;
    var el = document.createElement('div');
    el.className = 'toast';
    el.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
      (icon === 'error' ? '<circle cx="12" cy="12" r="9"/><path d="M12 7v6"/>' : '<path d="M20 6L9 17l-5-5"/>') +
      '</svg><span></span>';
    el.querySelector('span').textContent = message;
    host.appendChild(el);
    setTimeout(function () {
      el.classList.add('is-out');
      setTimeout(function () { el.remove(); }, 350);
    }, 3200);
  }

  /* --------------------------------------------------------------- reveals */
  function initReveals(root) {
    var items = $$('.reveal, .img-reveal, .reveal-mask', root || document);
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------------- header */
  function initHeader() {
    var hdr = $('[data-header]');
    if (!hdr) return;
    var last = window.scrollY;
    var ticking = false;
    function update() {
      var y = window.scrollY;
      hdr.classList.toggle('is-stuck', y > 8);
      if (y > 320 && y > last && !document.body.classList.contains('is-locked')) {
        hdr.classList.add('is-hidden');
      } else {
        hdr.classList.remove('is-hidden');
      }
      last = y;
      ticking = false;
    }
    on(window, 'scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  /* --------------------------------------------------------------- drawers */
  var Drawers = {
    open: null,
    lastFocus: null,
    scrim: null,
    init: function () {
      var self = this;
      this.scrim = $('[data-scrim]');
      on(document, 'click', function (e) {
        var opener = e.target.closest('[data-open]');
        if (opener) {
          e.preventDefault();
          self.show(opener.getAttribute('data-open'), opener);
          return;
        }
        if (e.target.closest('[data-close]') || e.target === self.scrim) {
          self.hide();
        }
      });
      on(document, 'keydown', function (e) {
        if (e.key === 'Escape' && self.open) self.hide();
        if (e.key === 'Tab' && self.open) self.trap(e);
      });
    },
    show: function (name, opener) {
      var el = $('[data-drawer="' + name + '"]');
      if (!el) return;
      if (this.open) this.hide(true);
      this.lastFocus = opener || document.activeElement;
      el.hidden = false;
      if (this.scrim) { this.scrim.hidden = false; }
      // force reflow so the transition runs
      void el.offsetWidth;
      el.classList.add('is-open');
      if (this.scrim) this.scrim.classList.add('is-open');
      document.body.classList.add('is-locked');
      this.open = el;
      var burger = $('.burger');
      if (burger && name === 'menu') burger.setAttribute('aria-expanded', 'true');
      var focusable = el.querySelector('input, button, a[href]');
      if (focusable) setTimeout(function () { focusable.focus(); }, 120);
      document.dispatchEvent(new CustomEvent('drawer:open', { detail: { name: name } }));
    },
    hide: function (silent) {
      var el = this.open;
      if (!el) return;
      el.classList.remove('is-open');
      if (this.scrim) this.scrim.classList.remove('is-open');
      document.body.classList.remove('is-locked');
      var burger = $('.burger');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      this.open = null;
      var self = this;
      setTimeout(function () {
        if (!self.open) {
          el.hidden = true;
          if (self.scrim) self.scrim.hidden = true;
        }
      }, 520);
      if (!silent && this.lastFocus) this.lastFocus.focus();
    },
    trap: function (e) {
      var nodes = $$('a[href], button:not([disabled]), input, select, textarea', this.open)
        .filter(function (n) { return n.offsetParent !== null; });
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };

  /* -------------------------------------------------------------- mobile submenus */
  function initSubmenus() {
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-submenu-toggle]');
      if (!btn) return;
      var panel = btn.nextElementSibling;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      if (panel) panel.hidden = open;
    });
  }

  /* ---------------------------------------------------------- announcement */
  function initAnnounce() {
    var bar = $('[data-announce][data-rotate]');
    if (!bar) return;
    var msgs = $$('.announce__msg', bar);
    if (msgs.length < 2) return;
    var i = 0;
    var delay = (parseInt(bar.getAttribute('data-rotate'), 10) || 5) * 1000;
    setInterval(function () {
      msgs[i].hidden = true;
      i = (i + 1) % msgs.length;
      msgs[i].hidden = false;
    }, delay);
  }

  /* ------------------------------------------------------------------ cart */
  var Cart = {
    refreshing: false,
    add: async function (id, quantity, button) {
      if (button) { button.dataset.loading = 'true'; button.disabled = true; }
      try {
        var res = await fetch(routes.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
        });
        var data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || strings.error);
        await this.refresh();
        Drawers.show('cart');
        toast(strings.added || 'Added to cart');
        return true;
      } catch (err) {
        toast(err.message || strings.error || 'Something went wrong', 'error');
        return false;
      } finally {
        if (button) { delete button.dataset.loading; button.disabled = false; }
      }
    },
    async change(key, quantity) {
      try {
        var res = await fetch(routes.cartChange, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
        var data = await res.json();
        if (!res.ok) throw new Error(data.description || strings.error);
        await this.refresh();
        if (document.body.classList.contains('template-cart')) window.location.reload();
        return data;
      } catch (err) {
        toast(err.message || strings.error, 'error');
      }
    },
    async refresh() {
      if (this.refreshing) return;
      this.refreshing = true;
      try {
        var res = await fetch(routes.root + '?sections=cart-drawer');
        var data = await res.json();
        var html = data['cart-drawer'];
        if (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-drawer="cart"]');
          var current = $('[data-drawer="cart"]');
          if (fresh && current) {
            var wasOpen = current.classList.contains('is-open');
            fresh.hidden = current.hidden;
            if (wasOpen) fresh.classList.add('is-open');
            current.replaceWith(fresh);
            if (wasOpen) Drawers.open = fresh;
          }
        }
        var cart = await (await fetch(routes.cart + '.js')).json();
        var count = $('[data-cart-count]');
        if (count) {
          count.textContent = cart.item_count;
          count.classList.toggle('is-on', cart.item_count > 0);
          count.classList.add('is-bump');
          setTimeout(function () { count.classList.remove('is-bump'); }, 520);
        }
      } catch (e) {
        /* leave the UI as-is; the cart page remains authoritative */
      } finally {
        this.refreshing = false;
      }
    }
  };

  function initCartEvents() {
    on(document, 'click', function (e) {
      var qtyBtn = e.target.closest('[data-qty][data-key]');
      if (qtyBtn) {
        e.preventDefault();
        Cart.change(qtyBtn.getAttribute('data-key'), parseInt(qtyBtn.getAttribute('data-qty'), 10));
        return;
      }
      var addVariant = e.target.closest('[data-add-variant]');
      if (addVariant) {
        e.preventDefault();
        Cart.add(parseInt(addVariant.getAttribute('data-add-variant'), 10), 1, addVariant);
      }
    });

    on(document, 'change', function (e) {
      var input = e.target.closest('[data-qty-input][data-key]');
      if (!input) return;
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 0) v = 0;
      Cart.change(input.getAttribute('data-key'), v);
    });
  }

  /* --------------------------------------------------------- product page */
  function initProduct() {
    var root = $('[data-product-root]');
    if (!root) return;

    var dataEl = $('[data-product-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    var form = $('[data-product-form]') || $('#ProductForm');
    var idInput = $('[data-variant-id]');
    var qtyInput = $('[data-pdp-qty]');
    var formQty = $('[data-form-qty]');
    var atc = $('[data-atc]');
    var atcLabel = $('[data-atc-label]');
    var priceEl = $('[data-price]');
    var compareEl = $('[data-compare]');
    var saveEl = $('[data-save]');
    var skuEl = $('[data-sku]');
    var stickyPrice = $('[data-sticky-price]');
    var stickyVariant = $('[data-sticky-variant]');
    var stickyAtc = $('[data-sticky-atc]');

    var picker = $('[data-variant-picker]', root);

    function optionGroups() {
      return picker ? $$('.opt', picker) : [];
    }

    function currentOptions() {
      var picks = [];
      optionGroups().forEach(function (group) {
        var sel = group.querySelector('.opt__btn.is-selected');
        picks.push(sel ? sel.getAttribute('data-option-value') : null);
      });
      return picks;
    }

    function findVariant(picks) {
      return variants.find(function (v) {
        return picks.every(function (p, i) { return !p || v.options[i] === p; });
      });
    }

    function markAvailability(picks) {
      optionGroups().forEach(function (group, gi) {
        $$('.opt__btn', group).forEach(function (btn) {
          var trial = picks.slice();
          trial[gi] = btn.getAttribute('data-option-value');
          var match = variants.find(function (v) {
            return trial.every(function (p, i) { return !p || v.options[i] === p; });
          });
          btn.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function render(variant) {
      if (!variant) {
        if (atc) { atc.disabled = true; }
        if (atcLabel) atcLabel.textContent = strings.unavailable || 'Unavailable';
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPrice) {
        stickyPrice.textContent = formatMoney(variant.price) + (variant.title && variant.title !== 'Default Title' ? ' · ' + variant.title : '');
      }
      if (stickyVariant) stickyVariant.textContent = variant.title;
      if (compareEl) {
        var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        compareEl.hidden = !hasCompare;
        if (hasCompare) compareEl.textContent = formatMoney(variant.compare_at_price);
        if (saveEl) {
          saveEl.hidden = !hasCompare;
          if (hasCompare) {
            var off = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            saveEl.textContent = (strings.save || 'Save') + ' ' + off + '%';
          }
        }
      }
      if (skuEl && variant.sku) skuEl.textContent = variant.sku;

      var available = variant.available;
      [atc, stickyAtc].forEach(function (b) { if (b) b.disabled = !available; });
      if (atcLabel) atcLabel.textContent = available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
      if (stickyAtc) {
        var sp = stickyAtc.querySelector('span');
        if (sp) sp.textContent = available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }

      // move the gallery to the variant image if there is one
      if (variant.featured_media && variant.featured_media.position) {
        selectSlide(variant.featured_media.position - 1);
      }
    }

    on(document, 'click', function (e) {
      var btn = e.target.closest('.opt__btn');
      if (!btn || !picker || !picker.contains(btn)) return;
      var group = btn.closest('.opt');
      $$('.opt__btn', group).forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      var label = group.querySelector('[data-option-selected]');
      if (label) label.textContent = btn.getAttribute('data-option-value');
      var picks = currentOptions();
      markAvailability(picks);
      render(findVariant(picks));
    });

    // quantity
    on(document, 'click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      if (!step || !qtyInput) return;
      var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10);
      qtyInput.value = Math.max(1, next);
      if (formQty) formQty.value = qtyInput.value;
    });
    on(qtyInput, 'change', function () {
      var v = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      qtyInput.value = v;
      if (formQty) formQty.value = v;
    });

    // add to cart
    on(form, 'submit', function (e) {
      e.preventDefault();
      var id = idInput ? idInput.value : null;
      if (!id) return;
      Cart.add(parseInt(id, 10), parseInt(qtyInput ? qtyInput.value : 1, 10) || 1, atc);
    });
    on(stickyAtc, 'click', function () {
      var id = idInput ? idInput.value : null;
      if (!id) return;
      Cart.add(parseInt(id, 10), parseInt(qtyInput ? qtyInput.value : 1, 10) || 1, stickyAtc);
    });

    markAvailability(currentOptions());

    /* ---- gallery ---- */
    var stage = $('[data-gal-stage]');
    var thumbs = $$('[data-gal-thumb]');
    var dots = $$('[data-gal-dots] i');

    function selectSlide(index) {
      if (!stage) return;
      var slide = stage.querySelector('[data-gal-slide="' + index + '"]');
      if (!slide) return;
      stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      setActive(index);
    }
    function setActive(index) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }
    thumbs.forEach(function (t) {
      on(t, 'click', function () { selectSlide(parseInt(t.getAttribute('data-gal-thumb'), 10)); });
    });
    if (stage) {
      var scrollTimer;
      on(stage, 'scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var idx = Math.round(stage.scrollLeft / stage.clientWidth);
          setActive(idx);
        }, 90);
      }, { passive: true });
    }

    // zoom
    var zoomer = $('[data-zoomer]');
    var zoomImg = $('[data-zoom-image]');
    on($('[data-gal-zoom]'), 'click', function () {
      var idx = Math.round(stage.scrollLeft / stage.clientWidth);
      var img = stage.querySelector('[data-gal-slide="' + idx + '"] img');
      if (!img || !zoomer) return;
      zoomImg.src = img.getAttribute('data-zoom-src') || img.src;
      zoomImg.alt = img.alt;
      zoomer.classList.add('is-open');
      document.body.classList.add('is-locked');
    });
    function closeZoom() {
      if (!zoomer) return;
      zoomer.classList.remove('is-open');
      document.body.classList.remove('is-locked');
    }
    on(zoomer, 'click', function (e) {
      if (e.target.closest('[data-zoom-close]') || e.target === zoomer || e.target === zoomImg) closeZoom();
    });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') closeZoom(); });

    /* ---- sticky buy bar ---- */
    var sticky = $('[data-sticky-buy]');
    var buy = $('[data-buy]');
    if (sticky && buy && 'IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { threshold: 0, rootMargin: '-120px 0px 0px 0px' });
      so.observe(buy);
    }

    /* ---- recently viewed memory ---- */
    try {
      var handle = root.getAttribute('data-handle');
      var seen = JSON.parse(localStorage.getItem('intimmacy:viewed') || '[]');
      seen = seen.filter(function (h) { return h !== handle; });
      seen.unshift(handle);
      localStorage.setItem('intimmacy:viewed', JSON.stringify(seen.slice(0, 8)));
    } catch (e) { /* private mode */ }
  }

  /* ------------------------------------------------------- recently viewed */
  async function initRecentlyViewed() {
    var section = $('[data-recently-viewed]');
    if (!section) return;
    var track = $('[data-rv-track]', section);
    var current = ($('[data-product-root]') || {}).getAttribute
      ? $('[data-product-root]').getAttribute('data-handle')
      : null;
    var handles = [];
    try { handles = JSON.parse(localStorage.getItem('intimmacy:viewed') || '[]'); } catch (e) { return; }
    handles = handles.filter(function (h) { return h && h !== current; }).slice(0, 4);
    if (!handles.length) return;

    var html = '';
    for (var i = 0; i < handles.length; i++) {
      try {
        var res = await fetch(routes.root + 'products/' + handles[i] + '?view=card');
        if (!res.ok) continue;
        var markup = await res.text();
        if (markup.trim()) html += '<div class="rv__item">' + markup + '</div>';
      } catch (e) { /* skip */ }
    }
    if (html) {
      track.innerHTML = html;
      section.hidden = false;
      initReveals(section);
    }
  }

  /* ------------------------------------------------------------ quick view */
  function initQuickView() {
    var modal = $('#QuickView');
    if (!modal) return;
    var body = $('[data-quick-view-body]', modal);

    on(document, 'click', async function (e) {
      var trigger = e.target.closest('[data-quick-view]');
      if (trigger) {
        e.preventDefault();
        var handle = trigger.getAttribute('data-quick-view');
        modal.hidden = false;
        void modal.offsetWidth;
        modal.classList.add('is-open');
        document.body.classList.add('is-locked');
        body.innerHTML = '<div class="qv__loading">' + (strings.loading || 'Loading…') + '</div>';
        try {
          var res = await fetch(routes.root + 'products/' + handle + '?view=quick');
          body.innerHTML = await res.text();
        } catch (err) {
          body.innerHTML = '<div class="qv__loading">' + (strings.error || 'Could not load') + '</div>';
        }
        return;
      }
      if (e.target.closest('[data-modal-close]')) {
        modal.classList.remove('is-open');
        document.body.classList.remove('is-locked');
        setTimeout(function () { modal.hidden = true; }, 420);
      }
    });

    // quick-view add to cart
    on(modal, 'submit', function (e) {
      var form = e.target.closest('[data-quick-form]');
      if (!form) return;
      e.preventDefault();
      var id = form.querySelector('[name="id"]');
      if (id) Cart.add(parseInt(id.value, 10), 1, form.querySelector('button[type="submit"]'));
    });
    on(modal, 'click', function (e) {
      var btn = e.target.closest('[data-qv-option]');
      if (!btn) return;
      var group = btn.closest('.opt');
      $$('.opt__btn', group).forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      var form = btn.closest('form');
      var idField = form.querySelector('[name="id"]');
      if (idField) idField.value = btn.getAttribute('data-variant-id');
      var priceOut = form.querySelector('[data-qv-price]');
      if (priceOut) priceOut.textContent = btn.getAttribute('data-variant-price');
    });
  }

  /* -------------------------------------------------------------- search */
  function initSearch() {
    var input = $('[data-search-input]');
    var out = $('[data-search-results]');
    if (!input || !out) return;
    var timer;

    on(input, 'input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) {
        out.innerHTML = '<p class="search-hint">' + (strings.searchHint || 'Type to search') + '</p>';
        return;
      }
      timer = setTimeout(async function () {
        try {
          var url = routes.predictive + '?q=' + encodeURIComponent(q) +
            '&resources[type]=product,page,article&resources[limit]=6&section_id=predictive-search';
          var res = await fetch(url);
          if (res.ok) {
            var text = await res.text();
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var results = doc.querySelector('[data-predictive]');
            if (results) { out.innerHTML = results.innerHTML; return; }
          }
        } catch (e) { /* fall through */ }
        out.innerHTML = '<p class="search-hint"><a class="link-arrow" href="' + routes.search +
          '?q=' + encodeURIComponent(q) + '">See all results for “' + q.replace(/</g, '&lt;') + '”</a></p>';
      }, 260);
    });
  }

  /* --------------------------------------------------------------- finder */
  function initFinder() {
    var root = $('[data-finder]');
    if (!root) return;

    var dataEl = $('[data-finder-data]', root);
    var data = {};
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var steps = $$('.finder__step[data-step]', root).filter(function (s) {
      return s.getAttribute('data-step') !== 'loading';
    });
    if (steps.length === 0) return;
    var loadingStep = root.querySelector('[data-step="loading"]');
    var resultEl = $('[data-finder-result]', root);
    var bar = $('[data-finder-bar]', root);
    var stepLabel = $('[data-finder-step-label]', root);
    var restart = $('[data-finder-restart]', root);
    var answers = [];
    var index = 0;

    function show(i) {
      steps.forEach(function (s, si) { s.classList.toggle('is-active', si === i); });
      if (loadingStep) loadingStep.classList.remove('is-active');
      resultEl.classList.remove('is-active');
      if (bar) bar.style.width = (i / steps.length) * 100 + '%';
      if (stepLabel) stepLabel.textContent = (data.strings.step || 'Question') + ' ' + (i + 1) + ' / ' + steps.length;
      if (restart) restart.hidden = i === 0 && answers.length === 0;
      index = i;
    }

    function tally() {
      var scores = {};
      answers.forEach(function (a) {
        String(a || '').split(',').forEach(function (key) {
          var k = key.trim();
          if (!k) return;
          scores[k] = (scores[k] || 0) + 1;
        });
      });
      var best = null;
      var bestScore = -1;
      (data.results || []).forEach(function (r) {
        var sc = scores[r.key] || 0;
        if (sc > bestScore) { bestScore = sc; best = r; }
      });
      return bestScore > 0 ? best : null;
    }

    function renderResult() {
      var match = tally();
      if (bar) bar.style.width = '100%';
      if (stepLabel) stepLabel.textContent = 'Your match';

      if (!match || !match.product || !match.product.url) {
        resultEl.innerHTML =
          '<p class="finder__q">' + esc(data.strings.match) + '</p>' +
          '<p class="lede">' + esc(data.strings.fallback) + '</p>' +
          '<div class="flex-cta mt-5"><a class="btn" href="' + data.strings.browse + '"><span>Browse all mattresses</span></a></div>';
        resultEl.classList.add('is-active');
        return;
      }

      var why = (match.why || '').split('\n').filter(Boolean).map(function (line) {
        return '<li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M20 6L9 17l-5-5"/></svg><span>' + esc(line) + '</span></li>';
      }).join('');

      var media = match.product.image
        ? '<img src="' + match.product.image + '" alt="' + esc(match.product.title) + '">'
        : '<div class="art skel" style="aspect-ratio:4/5;"></div>';

      var alt = '';
      if (match.alternate && match.alternate.url) {
        alt =
          '<div class="finder__alt">' +
            (match.alternate.image ? '<img src="' + match.alternate.image + '" alt="">' : '<span></span>') +
            '<div><p class="eyebrow eyebrow--bare">' + esc(data.strings.alt) + '</p>' +
            '<p style="font-weight:700;">' + esc(match.alternate.title) + '</p>' +
            '<p class="muted" style="font-size:var(--fs-sm);">' + esc(match.alternate.note || '') + '</p></div>' +
            '<a class="btn btn--sm btn--ghost" href="' + match.alternate.url + '"><span>View</span></a>' +
          '</div>';
      }

      resultEl.innerHTML =
        '<div class="finder__match">' +
          '<div>' + media + '</div>' +
          '<div>' +
            '<p class="eyebrow eyebrow--bare">' + esc(data.strings.match) + '</p>' +
            '<h3 style="font-size:var(--fs-2xl);margin-block:var(--sp-3) var(--sp-2);">' + esc(match.title || match.product.title) + '</h3>' +
            '<p class="muted">' + esc(match.audience || '') + '</p>' +
            (why ? '<p class="eyebrow eyebrow--bare mt-5">' + esc(data.strings.why) + '</p><ul class="finder__why">' + why + '</ul>' : '') +
            '<div class="flex-cta mt-6">' +
              '<a class="btn" href="' + match.product.url + '"><span>' + esc(data.strings.cta) + '</span></a>' +
              '<button class="btn btn--ghost" type="button" data-finder-reset><span>' + esc(data.strings.restart) + '</span></button>' +
            '</div>' +
          '</div>' +
        '</div>' + alt;

      resultEl.classList.add('is-active');
      steps.forEach(function (s) { s.classList.remove('is-active'); });
    }

    function esc(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    on(root, 'click', function (e) {
      var opt = e.target.closest('.finder__opt');
      if (opt) {
        var q = parseInt(opt.getAttribute('data-question'), 10);
        $$('.finder__opt', steps[q]).forEach(function (b) { b.classList.remove('is-picked'); });
        opt.classList.add('is-picked');
        answers[q] = opt.getAttribute('data-answer');
        if (restart) restart.hidden = false;
        setTimeout(function () {
          if (q + 1 < steps.length) {
            show(q + 1);
          } else {
            steps.forEach(function (s) { s.classList.remove('is-active'); });
            if (loadingStep) loadingStep.classList.add('is-active');
            setTimeout(function () {
              if (loadingStep) loadingStep.classList.remove('is-active');
              renderResult();
            }, 850);
          }
        }, 220);
        return;
      }
      if (e.target.closest('[data-finder-back]')) {
        if (index > 0) show(index - 1);
        return;
      }
      if (e.target.closest('[data-finder-restart]') || e.target.closest('[data-finder-reset]')) {
        answers = [];
        $$('.finder__opt', root).forEach(function (b) { b.classList.remove('is-picked'); });
        resultEl.innerHTML = '';
        show(0);
      }
    });

    show(0);
  }

  /* ---------------------------------------------------------- scroll story */
  function initStory() {
    var story = $('[data-story]');
    if (!story) return;
    var chapters = $$('[data-chapter]', story);
    var scenes = $$('[data-scene]', story);
    var rail = $$('[data-rail]', story);
    if (!chapters.length) return;

    function activate(i) {
      scenes.forEach(function (s, si) { s.classList.toggle('is-active', si === i); });
      rail.forEach(function (r, ri) { r.classList.toggle('is-active', ri === i); });
    }

    if (!('IntersectionObserver' in window)) { activate(0); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) activate(parseInt(en.target.getAttribute('data-chapter'), 10));
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    chapters.forEach(function (c) { io.observe(c); });

    var engaged = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { story.classList.toggle('is-engaged', en.isIntersecting); });
    }, { threshold: 0.05 });
    engaged.observe(story);

    rail.forEach(function (btn) {
      on(btn, 'click', function () {
        var target = chapters[parseInt(btn.getAttribute('data-rail'), 10)];
        if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    });
  }

  /* --------------------------------------------------------------- layers */
  function initLayers() {
    $$('[data-layers]').forEach(function (root) {
      var items = $$('[data-layer-index]', root);
      var slabs = $$('.layer-slab', root);
      if (!items.length) return;

      function select(n) {
        items.forEach(function (it) {
          var on_ = it.getAttribute('data-layer-index') === String(n);
          it.classList.toggle('is-active', on_);
          it.setAttribute('aria-expanded', String(on_));
        });
        slabs.forEach(function (sl) {
          var match = sl.getAttribute('data-layer') === String(n);
          sl.classList.toggle('is-lifted', match);
          sl.classList.toggle('is-dim', !match);
        });
      }

      items.forEach(function (it) {
        on(it, 'click', function () { select(it.getAttribute('data-layer-index')); });
      });
      slabs.forEach(function (sl) {
        on(sl, 'click', function () { select(sl.getAttribute('data-layer')); });
      });
      select(1);
    });
  }

  /* ----------------------------------------------------------- accordions */
  function initAccordions() {
    on(document, 'click', function (e) {
      var q = e.target.closest('.acc__q');
      if (!q) return;
      var item = q.closest('.acc__item');
      var open = item.classList.contains('is-open');
      var group = q.closest('[data-accordion]');
      if (group && !group.hasAttribute('data-multi')) {
        $$('.acc__item', group).forEach(function (i) {
          i.classList.remove('is-open');
          var b = i.querySelector('.acc__q');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
      }
      item.classList.toggle('is-open', !open);
      q.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ---------------------------------------------------------------- reels */
  function initReels() {
    $$('[data-reels]').forEach(function (root) {
      var track = $('[data-reels-track]', root);
      var videos = $$('[data-reel-video]', root);

      if ('IntersectionObserver' in window && !reduce) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var v = en.target;
            if (en.isIntersecting) {
              if (!v.src && v.dataset.src) {
                v.src = v.dataset.src;
                v.preload = "auto"; 
              }
              // Do NOT autoplay. 
            } else {
              v.pause(); // Pause if scrolled out of view
            }
          });
        }, { threshold: 0.2 });
        videos.forEach(function (v) { io.observe(v); });
      }

      on(root, 'click', function (e) {
        var mute = e.target.closest('[data-reel-mute]');
        if (mute) {
          var video = mute.parentElement.querySelector('video');
          if (!video) return;
          video.muted = !video.muted;
          mute.innerHTML = video.muted
            ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><path d="M4 9.5h3.5L12 6v12l-4.5-3.5H4z"/><path d="M16.5 10l4 4"/><path d="M20.5 10l-4 4"/></svg>'
            : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><path d="M4 9.5h3.5L12 6v12l-4.5-3.5H4z"/><path d="M16 9.5a3.6 3.6 0 0 1 0 5"/><path d="M18.5 7a7 7 0 0 1 0 10"/></svg>';
          return;
        }
        
        var reel = e.target.closest('.reel');
        if (reel) {
          var video = reel.querySelector('video');
          if (video && video.paused) {
            video.play();
          } else if (video) {
            video.pause();
          }
        }
      });

      function scrollBy(dir) {
        if (!track) return;
        var card = track.querySelector('.reel');
        var w = card ? card.offsetWidth + 16 : 260;
        track.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' });
      }
      on($('[data-reels-prev]', root), 'click', function () { scrollBy(-1); });
      on($('[data-reels-next]', root), 'click', function () { scrollBy(1); });
    });
  }

  /* -------------------------------------------------------------- counters */
  function initCounters() {
    var nums = $$('[data-count-to]');
    if (!nums.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        var target = parseFloat(String(el.getAttribute('data-count-to')).replace(/[^0-9.]/g, ''));
        var suffix = el.getAttribute('data-suffix') || '';
        if (isNaN(target) || reduce) return;
        var start = performance.now();
        var dur = 1400;
        function tick(now) {
          var p = Math.min((now - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = Math.round(target * eased);
          el.textContent = val.toLocaleString('en-IN') + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ------------------------------------------------ product recommendations */
  async function initRecommendations() {
    var section = $('[data-recommendations]');
    if (!section) return;
    var url = section.getAttribute('data-url');
    if (!url) return;
    try {
      var res = await fetch(url);
      if (!res.ok) return;
      var text = await res.text();
      var fresh = new DOMParser().parseFromString(text, 'text/html')
        .querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) {
        section.innerHTML = fresh.innerHTML;
        initReveals(section);
      }
    } catch (e) { /* section simply stays empty */ }
  }

  /* ------------------------------------------------------- collection tools */
  function initCollectionTools() {
    var form = $('[data-facet-form]');
    if (!form) return;

    function submit() {
      var params = new URLSearchParams();
      $$('input[type="checkbox"]:checked', form).forEach(function (cb) {
        params.append(cb.name, cb.value);
      });
      $$('input[type="number"]', form).forEach(function (input) {
        if (input.value !== '') params.set(input.name, input.value);
      });
      var sort = $('[data-sort]', form);
      if (sort && sort.value) params.set('sort_by', sort.value);
      window.location.search = params.toString();
    }

    $$('input[type="checkbox"]', form).forEach(function (cb) { on(cb, 'change', submit); });
    $$('input[type="number"]', form).forEach(function (input) {
      on(input, 'change', submit);
      on(input, 'keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });
    });
    on($('[data-sort]', form), 'change', submit);
    on(form, 'submit', function (e) { e.preventDefault(); submit(); });

    /* ---- mobile filter drawer ---- */
    var sidebar = document.getElementById('coll-sidebar');
    var overlay = document.getElementById('coll-sidebar-overlay');
    var opener = $('[data-filter-open]', form);
    if (!sidebar || !overlay) return;

    function openFilters() {
      sidebar.classList.add('is-open');
      overlay.classList.add('is-active');
      document.body.classList.add('is-locked');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      var first = sidebar.querySelector('input, button, a[href]');
      if (first) setTimeout(function () { first.focus(); }, 120);
    }
    function closeFilters() {
      sidebar.classList.remove('is-open');
      overlay.classList.remove('is-active');
      document.body.classList.remove('is-locked');
      if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
    }

    on(opener, 'click', openFilters);
    $$('[data-filter-close]', form).forEach(function (el) { on(el, 'click', closeFilters); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && sidebar.classList.contains('is-open')) closeFilters();
    });
  }

  /* ------------------------------------------------------------------ boot */
  function boot() {
    initReveals();
    initHeader();
    Drawers.init();
    initSubmenus();
    initAnnounce();
    initCartEvents();
    initProduct();
    initQuickView();
    initSearch();
    initFinder();
    initStory();
    initLayers();
    initAccordions();
    initReels();
    initCounters();
    initCollectionTools();
    initRecommendations();
    initRecentlyViewed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    initReveals(e.target);
    initFinder();
    initStory();
    initLayers();
    initReels();
    initCounters();
    initProduct();
  });
  document.addEventListener('shopify:section:select', function () { Drawers.hide(); });
})();
